import { render, staticRenderFns } from "./iiko_webhook.vue?vue&type=template&id=dd48ddd2&scoped=true&"
import script from "./iiko_webhook.vue?vue&type=script&lang=js&"
export * from "./iiko_webhook.vue?vue&type=script&lang=js&"
import style0 from "./iiko_webhook.vue?vue&type=style&index=0&id=dd48ddd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd48ddd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd48ddd2')) {
      api.createRecord('dd48ddd2', component.options)
    } else {
      api.reload('dd48ddd2', component.options)
    }
    module.hot.accept("./iiko_webhook.vue?vue&type=template&id=dd48ddd2&scoped=true&", function () {
      api.rerender('dd48ddd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/organizations/advanced/iiko_webhook.vue"
export default component.exports